import React, { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { VariableSizeList } from "react-window";
import { findIndex } from "lodash";
import { makeStyles } from "@mui/styles";

import { ROUTE_CARD } from "../../consts/sentryIds";

import { selectedRouteSelector } from "../../reducers/ownApp/selectors";
import {
  routeEditModeSelector,
  routeEditSelector,
} from "../../reducers/routeManagement/selectors";

import { View } from "../View";
import RouteCardBase from "./RouteCardBase";

const useStyles = makeStyles(({ typography }) => ({
  item: {
    marginTop: typography.pxToRem(2),
  },
  noScrollbar: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const RouteList = memo(({ routes, height = 900 }) => {
  const listRef = useRef();
  const styles = useStyles();
  const selectedRoute = useSelector(selectedRouteSelector);
  const routeEditMode = useSelector(routeEditModeSelector);
  const routeEdit = useSelector(routeEditSelector);

  useEffect(() => {
    if (!selectedRoute || !routes) return;
    listRef.current.resetAfterIndex(0, true);
    let selectedIndex = findIndex(
      routes,
      (route) => route.routeCode === selectedRoute.routeCode
    );
    if (selectedIndex < 0) return;
    listRef.current.scrollToItem(selectedIndex, "start");
  }, [routes, selectedRoute]);

  useEffect(() => {
    listRef?.current.resetAfterIndex(0, true);
  }, [routes]);

  const renderRow = ({ index, style }) => {
    const route = routes[index];
    const inEdit = routeEdit?.routeCode === route.routeCode;
    const selected = route.routeCode === selectedRoute?.routeCode;
    return (
      <View
        className={styles.item}
        key={index}
        style={style}
        id={`route-card-${index}`}
        sentryId={`${ROUTE_CARD}__${index}`}
      >
        <RouteCardBase
          height={style.height}
          route={route}
          editMode={routeEditMode}
          inEdit={inEdit}
          selected={selected}
        />
      </View>
    );
  };

  const getItemSize = (index) => {
    const route = routes[index];
    return 33 + 20 * route.roadSpeeds.length + 84;
  };

  return (
    <>
      {Array.isArray(routes) && (
        <VariableSizeList
          className={styles.noScrollbar}
          ref={listRef}
          height={height}
          itemCount={routes.length}
          itemSize={getItemSize}
          width={314}
        >
          {renderRow}
        </VariableSizeList>
      )}
    </>
  );
});

export default RouteList;
